// extracted by mini-css-extract-plugin
export default {"divider":"HeaderDivider_divider__xk6Gu","tall":"HeaderDivider_tall__UaXGp","short":"HeaderDivider_short__6An4U"};